module.exports = __webpack_public_path__ + "static/media/ssb_auth_white.2f2a3ad4.png";